/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscanaction2Inputs */

const en_menuscanaction2 = /** @type {(inputs: Menuscanaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the menu`)
};

const de_menuscanaction2 = /** @type {(inputs: Menuscanaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü einlesen`)
};

/**
* | output |
* | --- |
* | "Read the menu" |
*
* @param {Menuscanaction2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscanaction2 = /** @type {((inputs?: Menuscanaction2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscanaction2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscanaction2(inputs)
	return de_menuscanaction2(inputs)
});
export { menuscanaction2 as "menuScanAction" }